import React, { useContext } from 'react'
import { default as UIButton } from '@anvilco-pkg/ui/components/Button'
import { classString } from 'helpers'

import useAnalytics from 'lib/analytics/useAnalytics'
import { EVENT_CALL_TO_ACTION_CLICKED } from 'lib/analytics/events'
import { PROPERTY_LOCATION_ON_PAGE } from '@anvilco-pkg/customer-data/segment/eventProperties'

import { SectionContext } from 'components/page/Section'
import UniversalLink from 'components/UniversalLink'

export const CLASS_NAME = 'ms-button'

export default function Button ({
  isScrollBtn,
  to,
  className,
  onClick,
  ...others
}) {
  let sectionName

  if (SectionContext) {
    const { name } = useContext(SectionContext)
    sectionName = name
  }

  const ctaClickHandler = useAnalytics({
    eventName: EVENT_CALL_TO_ACTION_CLICKED,
  })

  const handleClick = (e) => {
    const properties = {
      click_url: to,
      click_text: e?.target?.innerText,
      [PROPERTY_LOCATION_ON_PAGE]: sectionName,
      action: 'Clicked',
      // label: ? ask more about this one
    }

    ctaClickHandler(properties)
  }

  // this will capture scroll links like 'signup' bc of the UniversalLink
  return (
    <UIButton
      to={to}
      className={classString([CLASS_NAME, className])}
      linkComponent={(props) => <UniversalLink {...props} disableAnalytics />}
      alwaysUseLinkComponent
      onClick={(e) => {
        handleClick(e)
        onClick && onClick(e)
      }}
      {...others}
    />
  )
}
